import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

// Simple scroll-reveal wrapper.
export const Reveal = ({ children, className = "", delay = 0, as = "div" }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      variants={fadeUp}
      custom={delay}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
    >
      {children}
    </Comp>
  );
};

// Masked line-by-line reveal (for hero headings) — CSS-driven for determinism.
export const LineReveal = ({ lines, className = "", lineClassName = "", start = 0.15 }) => {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" aria-hidden="true">
          <span
            className={`line-reveal block leading-[0.96] pb-[0.28em] ${lineClassName}`}
            style={{ animationDelay: `${start + i * 0.12}s` }}
          >
            {line}
          </span>
        </span>
      ))}
    </span>
  );
};
